import moment from 'moment';
import { useParams } from 'react-router-dom';
import React from 'react';
import { Spinner } from 'reactstrap';
import { useGuaranteedPrice } from '../../hooks/useGuaranteedPrice/useGuaranteedPrice';
import { t } from '../common/Translate';

export const RequestGuaranteedTime = () => {
  const { recordId } = useParams();
  const { guaranteedPrice, requestGuaranteedPrice, isGuaranteeLoading, roleIsViewer } = useGuaranteedPrice(recordId);

  return (
    <div>
      {guaranteedPrice.length !== 0 ? (
        <>
          <span>{t('tradeInRequested')}:</span>
          <span> {moment(guaranteedPrice.createdAt.date).format('DD-MM-YYYY HH:mm:ss')}</span>
        </>
      ) : (
        !roleIsViewer && (
          <button type="button" className="btn btn-1" onClick={() => requestGuaranteedPrice(recordId)}>
            {isGuaranteeLoading && <Spinner size="sm" />}
            {t('requestGuaranteedPriceCta')}
          </button>
        )
      )}{' '}
    </div>
  );
};
